import {connect} from "react-redux";
import RankingTooltip from "./RankingTooltip.jsx";

const RankingTooltipContainer = connect(
    (state, ownProps) => ({
        ...state.rankingTooltips.tooltips[ownProps.id],
        show: state.rankingTooltips.show,
        children: ownProps.children
    })
)(RankingTooltip);

export default RankingTooltipContainer